import React from "react";
import { Box, Typography, List, ListItem } from "@mui/material";

const TermsAndConditions = () => {
  return (
    <Box sx={{ maxWidth: 800, margin: "0 auto", padding: 3 }}>
      <Typography variant="h3" gutterBottom>
        Terms and Conditions
      </Typography>
      <Typography variant="body1" paragraph>
        Last updated: [15/02/2025]
      </Typography>
      <Typography variant="body1" paragraph>
        By using our website, you agree to these Terms and Conditions. Please
        read them carefully.
      </Typography>

      <Typography variant="h5" gutterBottom>
        1. Use of the Website
      </Typography>
      <Typography variant="body1" paragraph>
        You agree to use this website for lawful purposes only and not to engage
        in any activity that may harm the website or its users.
      </Typography>

      <Typography variant="h5" gutterBottom>
        2. Intellectual Property
      </Typography>
      <Typography variant="body1" paragraph>
        All content on this website, including text, images, and logos, is the
        property of Formation UK Company and is protected by copyright laws.
      </Typography>

      <Typography variant="h5" gutterBottom>
        3. Limitation of Liability
      </Typography>
      <Typography variant="body1" paragraph>
        We are not liable for any damages arising from your use of this website.
      </Typography>

      <Typography variant="h5" gutterBottom>
        4. Governing Law
      </Typography>
      <Typography variant="body1" paragraph>
        These Terms and Conditions are governed by the laws of England and
        Wales.
      </Typography>

      <Typography variant="h5" gutterBottom>
        5. Changes to These Terms
      </Typography>
      <Typography variant="body1" paragraph>
        We may update these Terms and Conditions from time to time. Any changes
        will be posted on this page.
      </Typography>
    </Box>
  );
};

export default TermsAndConditions;
